import { createSlice } from '@reduxjs/toolkit';

const getInitialState = () => ({
  targetingSectionTabs: 'locations_languages',
  targetingError: {
    placements: false,
    locations: false,
    languages: false,
    devices: false,
    os: false,
    custom_audience: false,
  },
});

const targetingPlacementsSlice = createSlice({
  name: 'targetingPlacements',
  initialState: getInitialState(),
  reducers: {
    changeTab: (state, action) => {
      state.targetingSectionTabs = action.payload;
    },
    updateErrorField: (state, action) => {
      const errorField = action.payload.errorField;
      state.targetingError[errorField] = action.payload.newValue;
    },
    clearState: () => getInitialState(),
  },
});

export const targetingPlacementsActions = targetingPlacementsSlice.actions;
export default targetingPlacementsSlice.reducer;
